import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import {
    provideAppEnvironmentInfo,
    provideLocalizationConfig,
    DEFAULT_LOCALIZATION_CONFIG,
} from '@contexts/jovdk-web';
import { provideThreeEnvironmentConfig } from '@contexts/jovdk-web-threejs';
import { AppEnvironmentHandler, environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(AppRoutingModule),
        provideHttpClient(),
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: './assets/i18n/',
                suffix: '.json',
            }),
            fallbackLang: 'en',
        }),
        provideLocalizationConfig(DEFAULT_LOCALIZATION_CONFIG),
        provideAppEnvironmentInfo({
            appVersion: environment.APP_VERSION,
            environmentName: environment.ENVIRONMENT_NAME,
            cdnUrl: environment.CDN_URL,
            apiUrl: environment.API_URL,
            isProduction: AppEnvironmentHandler.IsProd(),
            isLocal: AppEnvironmentHandler.IsLocal(),
        }),
        provideThreeEnvironmentConfig({
            cdnUrl: environment.CDN_URL,
            isLocal: AppEnvironmentHandler.IsLocal(),
        }),
        provideClientHydration(),
        provideAnimationsAsync(),
    ],
};
